import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {media, spacings} from "./theme.js";
import {Title} from "./typo.js";
import {Grid} from "./grid.js";
import Stack from "./stack.js";
import Component from "./editable-component.js";
import Image from "./image.js";
export default function HeroAbout(props) {
  const {title, hero_image, ...rest} = props;
  return /* @__PURE__ */ React.createElement(Component, {
    ...rest
  }, /* @__PURE__ */ React.createElement(HeroGrid, null, /* @__PURE__ */ React.createElement(CenteredStack, {
    spacing: "l"
  }, /* @__PURE__ */ React.createElement(Headline, {
    level: 2,
    as: "h1"
  }, title), /* @__PURE__ */ React.createElement(HeroImage, {
    ...hero_image,
    sizes: [900, 600]
  }))));
}
const HeroGrid = styled(Grid)`
  padding: 80px 0;

  ${media.mobile} {
    padding: ${spacings.m}px 0 0;
  }
`;
const Headline = styled(Title)`
  margin-bottom: 120px;

  ${media.mobile} {
    font-size: 38px;
    line-height: 46px;
    margin-bottom: 0;
    margin-top: 1em;
    order: 2;
  }
`;
const HeroImage = styled(Image)`
  max-height: 500px;
  max-width: 880px;
  margin: 0 auto;
  display: flex;
  margin: 0 auto;

  ${media.mobile} {
    max-height: 200px;
    max-width: 100%;
  }
`;
const CenteredStack = styled(Stack)`
  display: grid;
  align-content: center;

  ${media.mobile} {
    --spacing: ${spacings.m};
  }
`;
